/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Record_Toggle_TitleInputs */

const en_player_record_toggle_title = /** @type {(inputs: Player_Record_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record Enable/Disable`)
};

const fr_player_record_toggle_title = /** @type {(inputs: Player_Record_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer/Desactiver l'Enregistrement`)
};

const de_player_record_toggle_title = /** @type {(inputs: Player_Record_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufzeichnung aktivieren/deaktivieren`)
};

const it_player_record_toggle_title = /** @type {(inputs: Player_Record_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita/Disabilita registrazione`)
};

const ru_player_record_toggle_title = /** @type {(inputs: Player_Record_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включение/отключение записи`)
};

const es_player_record_toggle_title = /** @type {(inputs: Player_Record_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar/deshabilitar grabación`)
};

const zh_cn2_player_record_toggle_title = /** @type {(inputs: Player_Record_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用/禁用录制`)
};

const ja_player_record_toggle_title = /** @type {(inputs: Player_Record_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記録の有効化/無効化`)
};

const hi_player_record_toggle_title = /** @type {(inputs: Player_Record_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड सक्षम/अक्षम करें`)
};

const pt_pt2_player_record_toggle_title = /** @type {(inputs: Player_Record_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar/Desativar gravação`)
};

/**
* | output |
* | --- |
* | "Record Enable/Disable" |
*
* @param {Player_Record_Toggle_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_record_toggle_title = /** @type {((inputs?: Player_Record_Toggle_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Record_Toggle_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_record_toggle_title(inputs)
	if (locale === "de") return de_player_record_toggle_title(inputs)
	if (locale === "it") return it_player_record_toggle_title(inputs)
	if (locale === "ru") return ru_player_record_toggle_title(inputs)
	if (locale === "es") return es_player_record_toggle_title(inputs)
	if (locale === "zh-CN") return zh_cn2_player_record_toggle_title(inputs)
	if (locale === "ja") return ja_player_record_toggle_title(inputs)
	if (locale === "hi") return hi_player_record_toggle_title(inputs)
	if (locale === "pt-PT") return pt_pt2_player_record_toggle_title(inputs)
	return en_player_record_toggle_title(inputs)
});